import { useLanguage } from '../../i18n/LanguageContext'

export function LanguageToggle() {
  const { lang, setLang } = useLanguage()

  function toggle() {
    setLang(lang === 'he' ? 'en' : 'he')
  }

  return (
    <button
      onClick={toggle}
      className="
        fixed top-4 left-4 z-50
        px-3 py-1.5
        text-xs font-bold tracking-wide
        text-white/80 hover:text-white
        bg-white/10 hover:bg-white/20
        backdrop-blur-md
        border border-white/10
        rounded-full
        transition-all duration-200
        cursor-pointer
        select-none
      "
      aria-label={lang === 'he' ? 'Switch to English' : 'החלף לעברית'}
    >
      {lang === 'he' ? 'EN' : 'עב'}
    </button>
  )
}
